import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

// Code-split: each page loads only when the user navigates to it
const HomePage = lazy(() => import("@/pages/HomePage"));
const PropertiesPage = lazy(() => import("@/pages/PropertiesPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const TestimonialsPage = lazy(() => import("@/pages/TestimonialsPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const PropertyDetailPage = lazy(() => import("@/pages/PropertyDetailPage"));
const BrochurePropertyPage = lazy(() => import("@/pages/BrochurePropertyPage"));
const CategoryListingPage = lazy(() => import("@/pages/CategoryListingPage"));
const StaffPage = lazy(() => import("@/pages/StaffPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <>
      <Navbar transparent={isHome} />
      <main>
        <Suspense fallback={<div className="min-h-screen bg-[#FAFAFA]" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster richColors position="top-center" />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<PropertiesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/categories/:slug" element={<CategoryListingPage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/property/:id" element={<PropertyDetailPage />} />
          <Route path="/projects/:categorySlug/:propertySlug" element={<BrochurePropertyPage />} />
          {/* Catch-all: any unknown URL shows a friendly 404 page */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
